import { makeAutoObservable } from "mobx";

class Adaptive {
  isDesktop;

  isSmallDesktop;

  isTablet;

  isLargeMobile;

  isMobile;

  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);

    this.isDesktop = this.createMediaListener(
      "only screen and (min-width: 1280px)",
      (newValue) => {
        this.reactToChange("isDesktop", newValue);
      }
    );
    this.isSmallDesktop = this.createMediaListener(
      "only screen and (min-width: 1024px) and (max-width: 1279.9px)",
      (newValue) => {
        this.reactToChange("isSmallDesktop", newValue);
      }
    );
    this.isTablet = this.createMediaListener(
      "(min-width: 890px) and (max-width: 1023.9px)",
      (newValue) => {
        this.reactToChange("isTablet", newValue);
      }
    );
    this.isLargeMobile = this.createMediaListener(
      "(min-width: 361px) and (max-width: 889.9px)",
      (newValue) => {
        this.reactToChange("isLargeMobile", newValue);
      }
    );
    this.isMobile = this.createMediaListener(
      "(max-width: 360.9px)",
      (newValue) => {
        this.reactToChange("isMobile", newValue);
      }
    );
  }

  createMediaListener = (mediaString, handleChange) => {
    if (!window.matchMedia) {
      return null;
    }

    const media = window.matchMedia(mediaString);

    const listener = () => {
      handleChange(media.matches);
    };

    if (media.addEventListener) {
      media.addEventListener("change", listener);
    } else {
      media.addListener(listener);
    }

    handleChange(media.matches);

    return media.matches;
  };

  reactToChange = (field, value) => {
    this[field] = value;
  };
}

export default Adaptive;
